// material-ui
import { useTheme } from '@mui/material/styles';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoIconDark from 'assets/images/logo-icon-dark.svg';
 * import logoIcon from 'assets/images/logo-icon.svg';
 * import { ThemeMode } from 'config';
 *
 */

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      viewBox="0 0 40 40"
      version="1.1"
    >
      <g transform="scale(0.17) translate(-80, -150)" >
        <path
          d="m 94.38852,192.66685 c 10.39875,-17.99374 33.41883,-24.15663 51.41679,-13.7652 l 113.12761,65.31612 c 8.64295,4.99013 14.94815,13.20847 17.52857,22.84708 2.58044,9.63858 1.2247,19.9079 -3.76895,28.5488 -10.39875,17.99374 -33.41883,24.15661 -51.4168,13.76519 L 108.14812,244.06272 C 90.15016,233.67131 83.989775,210.66058 94.388518,192.66685 Z"
          fill="#ffff00"
          stroke="#000000"
        />
        <path
          d="m 126.6523,172.27695 c 20.78566,0 37.63226,16.8501 37.62794,37.63577 l -0.0272,130.5792 c -0.002,9.98163 -3.96925,19.55445 -11.02881,26.61252 -7.05954,7.05808 -16.63318,11.02326 -26.6148,11.02326 -20.78566,0 -37.632263,-16.8501 -37.627937,-37.63578 l 0.02718,-130.5792 c 0.0043,-20.78567 16.857937,-37.63577 37.643597,-37.63577 z"
          fill="#ff0000"
          stroke="#000000"
        />
        <path
          d="m 94.38647,360.59393 c -10.398743,-17.99374 -4.237488,-41.00293 13.76156,-51.39249 l 113.16655,-65.32291 c 8.64345,-4.98922 18.91659,-6.34153 28.55948,-3.75943 9.64288,2.58211 17.8656,8.88713 22.85925,17.52802 10.39877,17.99374 4.23749,41.00293 -13.76153,51.39248 l -113.16655,65.32291 c -17.99906,10.38956 -41.02001,4.22513 -51.41876,-13.76858 z"
          fill="#ff9900"
          stroke="#000000"
        />
      </g>
    </svg>
  );
}
